import type { Ref, TextareaHTMLAttributes } from 'react';
import styles from './Textarea.module.css';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  /** Grows with its content (where the browser supports `field-sizing`). */
  autoResize?: boolean;
  ref?: Ref<HTMLTextAreaElement>;
}

export function Textarea({
  invalid = false,
  autoResize = false,
  rows = 3,
  className,
  ...rest
}: TextareaProps) {
  return (
    <textarea
      rows={rows}
      className={[styles.textarea, invalid && styles.invalid, autoResize && styles.auto, className]
        .filter(Boolean)
        .join(' ')}
      aria-invalid={invalid || undefined}
      {...rest}
    />
  );
}
